export default {
  allMsg: 'Tous les messages',
  systemMsg: 'Messages système',
  personMsg: 'Messages manuels',
  unread: 'Non lu',
  seeDetail: 'Voir les détails',
  read: 'Lu',
  replyNow: 'Répondre maintenant',
  message: 'Message',
  operateSuccess: 'Opération réussie',
  holder: {
    searchHolder: "N° de colis/N° de commande/N° d'article",
  },
  addAcBuy: 'Rejoignez AcBuy Discord et gagnez 2000 ¥ en CASH !',
  joinNow: 'Rejoindre ici',
  flatActivity: 'Vente Black Friday Acbuy',
  joinNow1: 'Rejoindre maintenant',
  tips1: 'Profitez jusqu’à 70 % de réduction',
  tips2: 'Saisissez le code pour réclamer instantanément votre coupon de livraison de ¥110 !',
}
